import { Link } from 'react-router-dom';
import logo from '../../../assets/brand/logo-horizontal.svg';

const ErrorPage = () => (
  <div className="flex min-h-screen items-center justify-center bg-theme-bodybg p-4 dark:bg-themedark-bodybg">
    <div className="card mb-0 w-full max-w-md">
      <div className="card-body text-center">
        <img src={logo} alt="CashAfrica" className="mx-auto mb-8 h-8" />
        <p className="text-display font-bold text-primary-500">404</p>
        <h5 className="mb-2 mt-2 text-f-h5 font-semibold text-theme-headings dark:text-themedark-headings">
          Page not found
        </h5>
        <p className="mb-6 text-base text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor">
          The page you are looking for does not exist or has been moved.
        </p>
        <Link to="/" className="btn btn-primary">
          Go back home
        </Link>
      </div>
    </div>
  </div>
);

export default ErrorPage;
